// Drapeaux réglementaires des produits (stupéfiant / cytotoxique), lus dans
// l'onglet "Informations médicales" d'Odoo via l'action getProductFlags.
// Cache en mémoire par id produit pour la durée de la session.
import { callAction } from './odoo.js';

const cache = new Map(); // productId -> { stup, cyto, detail }

const VIDE = () => ({ stup: false, cyto: false, psy: false, mds: false, froid: false, detail: [] });
// La passerelle lit au plus 500 produits par appel : au-delà, les produits en
// trop revenaient « sans drapeau » (une journée compte plus de 500 produits).
const PAQUET = 400;

/**
 * strict = true : lève une erreur si un paquet n'a pas pu être lu (au lieu de
 * renvoyer les produits comme non sensibles). Un échec n'est jamais mis en
 * cache : le produit sera relu au prochain appel.
 */
export async function getProductFlags(ids, { strict = false } = {}) {
  const wanted = [...new Set((ids || []).map(Number).filter(Boolean))];
  const missing = wanted.filter(id => !cache.has(id));
  const echecs = [];
  for (let i = 0; i < missing.length; i += PAQUET) {
    const paquet = missing.slice(i, i + PAQUET);
    try {
      const res = await callAction('getProductFlags', { ids: paquet });
      paquet.forEach(id => cache.set(id, (res && res[id]) || VIDE()));
    } catch (e) {
      console.warn('getProductFlags:', e?.message);
      echecs.push(e?.message || String(e));
    }
  }
  if (strict && echecs.length) throw new Error('Drapeaux produits illisibles dans Odoo : ' + echecs[0]);
  const out = {};
  wanted.forEach(id => { out[id] = cache.get(id) || VIDE(); });
  return out;
}

export const FLAG_STYLES = {
  froid: { label: '❄️ FROID', bg: '#E8F4FD', color: '#1A5276', border: '#1A5276' },
  stup: { label: '🔒 STUPÉFIANT', bg: '#FDECEA', color: '#C0392B', border: '#C0392B' },
  psy: { label: '⚠️ PSYCHOTROPE', bg: '#FFF4E5', color: '#B7791F', border: '#B7791F' },
  mds: { label: '🩸 MDS', bg: '#E6F1FB', color: '#1A5276', border: '#1A5276' },
  cyto: { label: '☣️ CYTOTOXIQUE', bg: '#F3E8FF', color: '#6B21A8', border: '#6B21A8' },
};
export const FLAG_KEYS = ['froid', 'stup', 'psy', 'mds', 'cyto'];
export const hasAnyFlag = (f) => !!f && FLAG_KEYS.some(k => f[k]);

// Petit badge réutilisable (React sans JSX : évite une dépendance de fichier)
export function flagBadges(React, f, size = 9) {
  if (!hasAnyFlag(f)) return null;
  const mk = (k) => React.createElement('span', {
    key: k, style: { fontSize: size, fontWeight: 800, padding: '2px 6px', borderRadius: 4, background: FLAG_STYLES[k].bg, color: FLAG_STYLES[k].color, border: '1px solid ' + FLAG_STYLES[k].border, whiteSpace: 'nowrap', flexShrink: 0 },
  }, FLAG_STYLES[k].label);
  return FLAG_KEYS.filter(k => f[k]).map(mk);
}
